declare const __PACKAGE_VERSION__: string | undefined;
export const VERSION: string = __PACKAGE_VERSION__ ? __PACKAGE_VERSION__ : '0.0.0-test';
